export enum SizeUnits {
	BYTE = "BYTE",
	KI_B = "KI_B",
	MI_B = "MI_B",
	GI_B = "GI_B",
	TI_B = "TI_B",

}
